exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".link-save-banner-large__config--block{display:block;width:56px}.link-save-banner-large__config--inline-block{display:inline-block}.link-save-banner-large__config--center{display:inline-flex;align-items:center;justify-content:center}.link-save-banner-large__config--height-normal{height:16px}.link-save-banner-large__config--margin-horizontal-small{margin:0 2px}.link-save-banner-large__config--up-small{margin-top:-3px}.link-save-banner-large__config--down-large{transform:translateY(10px)}.link-save-banner-large__config--font-huge{font-size:22px;font-weight:700}.link-save-banner-large__config--font-large{font-size:16px;letter-spacing:.2px;line-height:20px;font-weight:700}.link-save-banner-large__config--font-normal{font-size:12px;letter-spacing:.1px;line-height:16px;font-weight:600}.link-save-banner-large__config--font-small{font-size:11px;font-weight:600}.link-save-banner-large__config--font-weight-semi-bold{font-weight:600}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/sass-loader/dist/cjs.js??ref--1-3!./shared/interim/product/link-save-primary-banner/_linksave-config.scss
// module id = 835
// module chunks = 0